// extracted by mini-css-extract-plugin
var _1 = "ConfirmTestModal__backdrop--phtuL";
var _2 = "ConfirmTestModal__beast--GrMWE";
var _3 = "ConfirmTestModal__button--UJ_ws";
var _4 = "ConfirmTestModal__buttonToLeft--inP7l";
var _5 = "ConfirmTestModal__buttons--hZmTa";
var _6 = "ConfirmTestModal__centered--oIin5";
var _7 = "ConfirmTestModal__closeButton--CGwA8";
var _8 = "ConfirmTestModal__content--U62qC fontSize__instructions--TOHcR CoreGeneral__roboto--UlmjE";
var _9 = "ConfirmTestModal__contentBeast--bUcdC";
var _a = "ConfirmTestModal__iconShadow--zQHOQ";
var _b = "ConfirmTestModal__main--TKIQU";
var _c = "ConfirmTestModal__scrollContent--Hkb9x";
var _d = "ConfirmTestModal__title--gIh71 CoreGeneral__robotoSlab--X8lgW";
export { _1 as "backdrop", _2 as "beast", _3 as "button", _4 as "buttonToLeft", _5 as "buttons", _6 as "centered", _7 as "closeButton", _8 as "content", _9 as "contentBeast", _a as "iconShadow", _b as "main", _c as "scrollContent", _d as "title" }
